<template>
  <v-dialog v-model="showAddDialog" width="700" persistent>
    <v-card>
      <v-card-title class="secondary white--text">
        Add Customer Tariff
        <v-spacer></v-spacer>
        <v-btn icon @click="resetForm(), (showAddDialog = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        v-if="formErrors && formErrors.non_field_errors"
        class="mt-2"
      >
        <v-alert close-icon="mdi-close" dense type="error">
          <v-list
            class="pa-0"
            dense
            style="background: inherit !important"
            v-for="(error, i) in formErrors.non_field_errors"
            :key="i"
          >
            <v-list-item dense style="min-height: 20px !important">
              <span>{{ i + 1 }} .</span><span>{{ error }}</span>
            </v-list-item>
          </v-list>
        </v-alert>
      </v-card-text>

      <v-card-text class="pa-5">
        <v-form ref="customerContractForm" v-model="isValid" lazy-validation>
          <v-row class="ma-0">
            <v-col cols="12" lg="6" class="Form-Columns-Dense">
              <Autocomplete
                :loading="listLoading"
                :totalItems="customerCount"
                :items="allCustomerList"
                @updateList="getCustomerList"
                label="Select Customer *"
                itemText="company_title"
                itemValue="id"
                :rules="[(v) => !!v || 'Customer is Required']"
                hide-details="auto"
                v-model="contractDetails.customer"
                :error-messages="formErrors.customer"
                @input="delete formErrors.customer"
              />
            </v-col>

            <v-col cols="12" lg="6" class="Form-Columns-Dense">
              <DateField
                :inputProps="{
                  dense: true,
                  label: 'Start Date *',
                  'hide-details': 'auto',
                  rules: [(val) => !!val || 'Start Date is required!'],
                  'error-messages': formErrors.start_date,
                }"
                required
                :min="today"
                v-model="contractDetails.start_date"
                @input="delete formErrors.start_date"
              />
            </v-col>

            <v-col cols="12" lg="6" class="Form-Columns-Dense">
              <DateField
                :inputProps="{
                  dense: true,
                  label: 'End Date *',
                  'hide-details': 'auto',
                  rules: [(val) => !!val || 'End Date is required!'],
                  'error-messages': formErrors.end_date,
                }"
                required
                :min="contractDetails.start_date"
                v-model="contractDetails.end_date"
                @input="delete formErrors.end_date"
              />
            </v-col>

            <v-col cols="12" lg="6" class="Form-Columns-Dense">
              <InputField
                type="text"
                label="Admin Remarks"
                hide-details="auto"
                v-model="contractDetails.admin_remarks"
                :error-messages="formErrors.admin_remarks"
                @input="delete formErrors.admin_remarks"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-5">
        <v-btn class="ml-auto" @click="resetForm(), (showAddDialog = false)" depressed>
          Reset
        </v-btn>
        <v-btn
          :disabled="!isValid"
          @click="submitForm"
          depressed
          color="primary"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import Autocomplete from "@/components/FormBaseComponents/Autocomplete.vue";
import DateField from "@/components/FormBaseComponents/DateField.vue";

export default {
  components: {
    InputField,
    Autocomplete,
    DateField,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getCustomerList();
      }
    },
  },
  data() {
    return {
      contractDetails: {
        created_from: "Admin",
      },
      formErrors: {},
      allCustomerList: [],
      listLoading: false,
      customerCount: 0,
      isValid: true,
      today: new Date().toISOString().slice(0, 10),
    };
  },
  computed: {
    showAddDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getCustomerList(params = {}) {
      this.listLoading = true;
      params = {
        company_type: "Customer",
        offset: 0,
        limit: 10,
        is_active: true,
        ...params,
      };
      this.$api.company
        .getCompanySelectList(params)
        .then((res) => {
          this.listLoading = false;
          if ("count" in res) {
            this.customerCount = res.count;
          }

          if (params.offset == 0) {
            this.allCustomerList = res.data;
          } else {
            this.allCustomerList.push(...res.data);
          }
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    submitForm() {
      this.$bus.$emit("showLoader", true);
      let payload = { ...this.contractDetails, customer_contract_v2_rates: [] };

      if (payload.customer && typeof payload.customer == "object") {
        payload.customer = payload.customer.id;
      }

      this.$api.customerContractV2
        .addCustomerContractV2(payload)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Customer Tariff added Successfully!",
            color: "success",
          });
          this.resetForm();
          this.showAddDialog = false;
          this.$emit("submitted", res.data && res.data.response_data);
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't add Customer Tariff!",
            color: "error",
          });
          this.formErrors = { ...this.formErrors, ...err.data };
        });
    },
    resetForm() {
      if (this.$refs.customerContractForm) {
        this.$refs.customerContractForm.reset();
      }
      this.formErrors = {};
      this.contractDetails = {
        created_from: "Admin",
      };
    },
  },
};
</script>
